export const MAIN_BODY_FONT = 'Inter';

export const MAIN_TITLE_FONT = 'StabilGrotesk';
